import { combineReducers } from 'redux'

import auth from './auth'
import badge from './badge'
import user from './user'

export default combineReducers({
  auth,
  badge,
  user,
})
